module.exports = __webpack_public_path__ + "static/img/signupbanner.98c9e92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/signupbanner.png
// module id = iN1d
// module chunks = 5